module.exports = __webpack_public_path__ + "static/media/sc.e36d5f60.svg";